// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"2331e1c5","453":"bc0a2d01","455":"4d9fad94"}[chunkId] + ".chunk.js";
};